// Vita AI Shopping Assistant — typewriter effect for the floating input bar
// Standalone, isolated from the Webflow runtime. Loaded separately in index.html.
(function() {
    var prompts = [
        "Can you recommend a laptop for personal use?",
        "Show me useful products for my home",
        "I need new tires.",
        "I am shopping for electronics."
    ];
    function start() {
        var el = document.getElementById("vitaType");
        if (!el) return;
        var promptIndex = 0;
        var charIndex = 0;
        var deleting = false;
        function tick() {
            var current = prompts[promptIndex];
            var delay;
            if (deleting) {
                el.textContent = current.substring(0, charIndex - 1);
                charIndex--;
                delay = 40;
            } else {
                el.textContent = current.substring(0, charIndex + 1);
                charIndex++;
                delay = 75;
            }
            if (!deleting && charIndex === current.length) {
                delay = 2200;
                deleting = true;
            } else if (deleting && charIndex === 0) {
                deleting = false;
                promptIndex = (promptIndex + 1) % prompts.length;
                delay = 400;
            }
            setTimeout(tick, delay);
        }
        setTimeout(tick, 900);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
    else start();
})();

//# sourceMappingURL=index.0c98f8c2.js.map
